// Sobrescrever a função productInstallment para usar o preço original (sem desconto) no cálculo do parcelamento
function productInstallment() {
    const installmentsContainer = document.querySelector(".product__info-container .price__container .installments");
    // Buscar apenas o price-item--last que está dentro de .price__sale (ignorar o de unit price)
    const priceItems = document.querySelectorAll(".product__info-container .price__sale .price-item--last");
    
    if (installmentsContainer && priceItems) {
      priceItems.forEach(priceItem => {
        // Usar o preço original do atributo data-original-price ao invés do innerHTML
        let originalPrice = priceItem.getAttribute('data-original-price');
        
        if (originalPrice) {
          // Preço vem em centavos do Liquid
          originalPrice = Number(originalPrice) / 100;
        } else {
          // Fallback: se não houver data-original-price, usar o innerHTML
          originalPrice = priceItem.innerHTML;
          originalPrice = originalPrice.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
          originalPrice = Number(originalPrice);
        }
        
        // Navegar corretamente até o elemento .installments
        // priceItem está dentro de .price__sale, e .installments é irmão de .price__sale
        const priceContainer = priceItem.closest('.price__container');
        const installmentElement = priceContainer ? priceContainer.querySelector('.installments') : null;
        
        if (!installmentElement) return;
        
        // Encontrar a melhor opção de parcelamento
        let bestInstallments = 1;
        let bestValue = originalPrice;
        let isInterestFree = false;
        
        for (let i = maximumInstallments; i >= 2; i--) {
          const installmentValue = (originalPrice / i).toFixed(2);
          const interestRate = eval(`installmentInterest${i}x`);
          const interestValue = (interestRate * originalPrice).toFixed(2);
          
          if (interestFreeInstallments >= i && installmentValue >= minimumInstallmentAmount) {
            bestInstallments = i;
            bestValue = installmentValue;
            isInterestFree = true;
            break;
          } else if (interestValue >= minimumInstallmentAmount) {
            bestInstallments = i;
            bestValue = interestValue;
            isInterestFree = false;
            break;
          }
        }
        
        // Aplicar os valores encontrados
        if (bestInstallments > 1) {
          installmentElement.querySelector(".installment").innerHTML = `<span>${bestValue.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
          installmentElement.querySelector(".times").innerHTML = `${bestInstallments}x`;
          
          if (isInterestFree) {
            installmentElement.classList.add("interest-free");
            installmentElement.classList.remove("with-interest");
          } else {
            installmentElement.classList.add("with-interest");
            installmentElement.classList.remove("interest-free");
          }
          
          installmentElement.classList.remove("hide");
        }
      });
    }
  }
  
  // Executar a função corrigida imediatamente após definir
  if (typeof maximumInstallments !== 'undefined') {
    productInstallment();
  }

// Função para calcular parcelamento nos cards da listagem (página inicial)
function productInstallmentList() {
  const cards = document.querySelectorAll('.card-wrapper');
  
  cards.forEach(card => {
    const priceItem = card.querySelector('.price-item--last');
    const installmentElement = card.querySelector('.installments');
    
    if (!priceItem || !installmentElement) return;
    
    let originalPrice = priceItem.getAttribute('data-original-price');
    
    if (originalPrice) {
      originalPrice = Number(originalPrice) / 100;
    } else {
      originalPrice = priceItem.innerHTML;
      originalPrice = originalPrice.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
      originalPrice = Number(originalPrice);
    }
    
    // Encontrar a melhor opção de parcelamento
    let bestInstallments = 1;
    let bestValue = originalPrice;
    let isInterestFree = false;
    
    for (let i = maximumInstallments; i >= 2; i--) {
      const installmentValue = (originalPrice / i).toFixed(2);
      const interestRate = eval(`installmentInterest${i}x`);
      const interestValue = (interestRate * originalPrice).toFixed(2);
      
      if (interestFreeInstallments >= i && installmentValue >= minimumInstallmentAmount) {
        bestInstallments = i;
        bestValue = installmentValue;
        isInterestFree = true;
        break;
      } else if (interestValue >= minimumInstallmentAmount) {
        bestInstallments = i;
        bestValue = interestValue;
        isInterestFree = false;
        break;
      }
    }
    
    // Aplicar os valores
    if (bestInstallments > 1) {
      const installmentSpan = installmentElement.querySelector(".installment");
      const timesSpan = installmentElement.querySelector(".times");
      
      if (installmentSpan && timesSpan) {
        installmentSpan.innerHTML = `<span>${bestValue.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
        timesSpan.innerHTML = `${bestInstallments}x`;
        
        if (isInterestFree) {
          installmentElement.classList.add("interest-free");
          installmentElement.classList.remove("with-interest");
        } else {
          installmentElement.classList.add("with-interest");
          installmentElement.classList.remove("interest-free");
        }
        
        installmentElement.classList.remove("hide");
      }
    }
  });
}

// Executar para os cards da listagem
if (typeof maximumInstallments !== 'undefined') {
  productInstallmentList();
}